module.exports = __webpack_public_path__ + "static/media/sg.5e6ed3f1.svg";